import React, {Component} from 'react';
import PortalAdminDraggable from './PortalAdminDraggable';
import {Droppable, Draggable} from 'react-beautiful-dnd';
import Button from 'ROOT/src/components/formElements/Button';
import TickBox from 'ROOT/src/components/formElements/TickBox';

import sAction from 'sAction';

class PortalAdminItems extends React.Component {
    constructor() {
        super();
        this.state = {
            selected: [],
        };
    }

    assignUsers() {
        const users = this.state.selected;

        if (users.length == 0) {
            sAction.error(sAction.translate('LBL_ERROR_NO_USER_SELECTED', 'acm_portal_users'));
        } else {
            this.props.massAssigneUsers(users);
        }
    }

    selectUser(id, value) {
        let selected = this.state.selected;
        if (value) {
            if (!selected.includes(id)) {
                selected.push(id);
            }
        } else {
            if (selected.includes(id)) {
                selected = selected.filter(function(it) {
                    return it !== id;
                });
            }
        }
        this.setState({
            selected: selected,
        });
    }

    selectItems(value) {
        const items = [];
        const ignoredUsers = this.props.ignoredUsers;
        console.log('ignoredUsers', ignoredUsers);
        this.props.items.forEachObject((it) => {
            items.push(it.id);
        });
        let selected = this.state.selected;
        if (value) {
            items.forEach((id) => {
                if (!selected.includes(id) && !ignoredUsers.includes(id)) {
                    selected.push(id);
                }
            });
        } else {
            const newSelected = [];
            selected.forEach((id) => {
                if (ignoredUsers.includes(id)) {
                    newSelected.push(id);
                }
            });
            selected = newSelected;
        }
        this.setState({
            selected: selected,
        });
    }

    render() {
        const itemComp = [];
        const dropId = this.props.dropId;
        this.props.items.forEachObject((item, ind) => {
            itemComp.push(
                <Draggable draggableId={item.id} index={item.index} key={item.id} type="ROLES">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <PortalAdminDraggable
                                compId={dropId+item.id}
                                record={item.id}
                                selectUser={(id, val) => this.selectUser(id, val)}
                                checkedUser={this.state.selected.includes(item.id)}
                                name={item.name}
                                branch={item.branch}
                                usersCnt={item.usersCnt}
                                type={this.props.type}
                                isDragging={snapshot.isDragging}
                                customDragClass="dragAllowed" />
                        </div>
                    )}
                </Draggable>,
            );
        });

        let btn = null;
        let checkComp = null;
        if (this.props.type == 'USERS') {
            btn = <Button className="portalAdminAssignBtn" onClick={() => {
                this.assignUsers();
            }}>{sAction.translate('LBL_MASSASSIGN', 'acm_portal_users')}</Button>;
            checkComp = <TickBox
                className="portalAdminTick portalAdminMassTick"
                onChange={(value) => this.selectItems(value)}
            />;
        }


        return <div className={'portalAdminColumn ' + this.props.customClass}>
            <div className="portalAdminColumnHeader">
                {checkComp}

                <div className="search adminTreeSearch">
                    <input
                        type="text"
                        className="search"
                        placeholder={sAction.translate('LBL_SEARCH')+'...'}
                        onChange={(ev) => this.props.search(ev.target.value)}
                    />

                </div>
                {btn}
            </div>
            <Droppable droppableId={dropId} type={this.props.type}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {itemComp}
                        {provided.placeholder}
                    </div>

                )}
            </Droppable>
        </div>;
    }
}
export default PortalAdminItems;
